import React, { useState, useEffect } from 'react'
import { graphql } from 'gatsby'
import Modal from 'react-modal'
import style from './team-member-card.mod.scss'
import { GatsbyImage } from 'gatsby-plugin-image'

// Make sure to bind modal to your appElement
if (typeof window !== 'undefined') {
  Modal.setAppElement('#___gatsby')
}

const TeamMemberCard = props => {
  const {
    name,
    role,
    image,
    clinic,
    description,
    modifiers = [],
    teamClinic
  } = props
  const { gatsbyImageData, alt } = image
  const [modalIsOpen, setIsOpen] = useState(false)

  const openModal = () => setIsOpen(true)
  const closeModal = () => setIsOpen(false)

  useEffect(() => {
    if (modalIsOpen) {
      document.documentElement.style.overflow = 'hidden'
    } else {
      document.documentElement.style.overflow = ''
    }

    // Cleanup function to ensure overflow is restored when component unmounts
    return () => {
      document.documentElement.style.overflow = ''
    }
  }, [modalIsOpen])

  const renderCardContent = () => (
    <>
      <div className={style['team-member-card__image']}>
        <GatsbyImage image={gatsbyImageData} alt={alt || ''} />
      </div>
      {name && <h3 className={style['team-member-card__name']}>{name}</h3>}
    </>
  )

  const renderModalContent = () => (
    <div className={style['team-member-modal']}>
      <button
        className={style['team-member-modal__close']}
        onClick={closeModal}
        aria-label="Close modal"
      >
        ×
      </button>
      <div className={style['team-member-modal__content']}>
        <div className={style['team-member-modal__image']}>
          <GatsbyImage image={gatsbyImageData} alt={alt || ''} />
        </div>
        <div className={style['team-member-modal__details']}>
          {name && <h2 className={style['team-member-modal__name']}>{name}</h2>}
          {role && <p className={style['team-member-modal__role']}>{role}</p>}
          {clinic?.name && clinic.directions && (
            <a
              className={style['team-member-modal__clinic']}
              href={clinic.directions}
              target="_blank"
              rel="noopener noreferrer"
            >
              {clinic.name}
            </a>
          )}
          {description && (
            <div
              className={style['team-member-modal__description']}
              dangerouslySetInnerHTML={{ __html: description }}
            />
          )}
        </div>
      </div>
    </div>
  )

  return (
    <>
      <div
        className={[style['team-member-card'], ...modifiers].join(' ')}
        onClick={openModal}
        role="button"
        tabIndex={0}
        onKeyPress={e => {
          if (e.key === 'Enter' || e.key === ' ') {
            openModal()
          }
        }}
      >
        {renderCardContent()}
        <div className={style['team-member-card__content']}>
          {role && <p className={style['team-member-card__role']}>{role}</p>}
          {clinic?.name && clinic.directions && (
            <a
              className={style['team-member-card__clinic']}
              href={clinic.directions}
              target="_blank"
              rel="noopener noreferrer"
              onClick={e => e.stopPropagation()}
            >
              {clinic.name}
            </a>
          )}
          {description && (
            <div
              className={style['team-member-card__description']}
              dangerouslySetInnerHTML={{ __html: description }}
            />
          )}
        </div>
      </div>

      <Modal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        className={style['team-member-modal__overlay']}
        overlayClassName={style['team-member-modal__overlay']}
        contentLabel={`${name}'s details`}
      >
        {renderModalContent()}
      </Modal>
    </>
  )
}

export default TeamMemberCard

export const query = graphql`
  fragment TeamMemberCard on DatoCmsTeamMemberCard {
    name
    role
    description
    clinic {
      id
      name
      directions
    }
    id
    image {
      gatsbyImageData(
        layout: CONSTRAINED
        imgixParams: { h: "200", w: "200", fit: "crop", q: 60 }
      )
      alt
    }
  }
`
